import { createFeatureSelector, createSelector } from '@ngrx/store'
import { ACTIVITY_FEED_POSTS_FEATURE_KEY, State, activityFeedPostsAdapter } from './activity-feed-posts.reducer'

// Lookup the 'ActivityFeedPosts' feature state managed by NgRx
export const getActivityFeedPostsState = createFeatureSelector<State>(ACTIVITY_FEED_POSTS_FEATURE_KEY)

const { selectAll, selectEntities } = activityFeedPostsAdapter.getSelectors()

export const getActivityFeedPostsLoaded = createSelector(getActivityFeedPostsState, (state: State) => state.loaded)

export const getAllActivityFeedPosts = createSelector(getActivityFeedPostsState, (state: State) => selectAll(state))

export const getActivityFeedPostsEntities = createSelector(getActivityFeedPostsState, (state: State) =>
  selectEntities(state),
)

export const getSelectedId = createSelector(getActivityFeedPostsState, (state: State) => state.selectedId)

export const getSelected = createSelector(getActivityFeedPostsEntities, getSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)

export const getActivityFeedPostsNext = createSelector(getActivityFeedPostsState, (state: State) => state.next)
export const getActivePage = createSelector(getActivityFeedPostsState, (state: State) => state.activePage)
export const getCount = createSelector(getActivityFeedPostsState, (state: State) => state.count)

export const newActivityFeedPost = createSelector(
  getActivityFeedPostsState,
  (state: State) => state.newActivityFeedPost,
)

export const getSubmitting = createSelector(getActivityFeedPostsState, (state: State) => state.submitting)
